"use client";

import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../hooks/useAuth";
import { channelsAPI, handleApiError } from "../../../services/api";
import "./JoinRequestModal.css";

const JoinRequestModal = ({ isOpen, onClose, channelId, channelName, onRequestSent }) => {
  const { t } = useTranslation();
  const { getUserType } = useAuth();
  
  // Get user type color
  const currentUserType = getUserType();
  const getUserTypeColor = (userType) => {
    const userTypeConfig = {
      'PET_GUARDIAN': '#8548A8',
      'VETERINARIAN': '#00D4B3',
      'SERVICE_PROVIDER': '#D65745',
      'SERVICE_PROVIDER': '#D65745',
      'CLINIC_MODERATOR': '#2A8AD2',
    };
    return userTypeConfig[userType] || '#8548A8';
  };
  const userTypeColor = getUserTypeColor(currentUserType);
  
  const [requestMessage, setRequestMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    setIsSubmitting(true);

    try {
      await channelsAPI.requestJoinChannel(channelId, requestMessage);
      onRequestSent(requestMessage);
      setRequestMessage("");
      onClose();
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="join-request-modal-overlay" onClick={onClose}>
      <div className="join-request-modal" onClick={(e) => e.stopPropagation()} style={{ '--user-type-color': userTypeColor }}>
        <div className="join-request-modal-header">
          <h2 className="join-request-modal-title">{t("joinRequestModal.title", { name: channelName })}</h2>
          <button className="join-request-modal-close" onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="join-request-modal-form">
          <div className="join-request-form-group">
            <label className="join-request-form-label">{t("joinRequestModal.messageLabel")}</label>
            <textarea
              value={requestMessage}
              onChange={(e) => setRequestMessage(e.target.value)}
              placeholder={t("joinRequestModal.messagePlaceholder")}
              className="join-request-form-textarea"
              rows="5"
              maxLength={500}
            />
            <span className="join-request-form-char-count">
              {t("joinRequestModal.charCount", { count: requestMessage.length, max: 500 })}
            </span>
          </div>

          <div className="join-request-modal-info">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="13"></line>
              <circle cx="12" cy="16" r="1"></circle>
            </svg>
            <p>{t("joinRequestModal.info")}</p>
          </div>

          <div className="join-request-modal-actions">
            <button type="button" className="join-request-modal-cancel" onClick={onClose}>
              {t("joinRequestModal.buttons.cancel")}
            </button>
            <button type="submit" className="join-request-modal-submit" disabled={isSubmitting}>
              {isSubmitting ? t("joinRequestModal.buttons.submitting") : t("joinRequestModal.buttons.submit")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default JoinRequestModal;

